import { useEffect, useState } from "react";
import api from "../../constants/api.js";
import { useNavigate } from "react-router-dom";
import "./videos.css";

function Videos() {
  const [videos, setVideos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function carregar() {
      try {
        const res = await api.get("/videos");
        setVideos(res.data || []);
      } catch (err) {
        console.error("Erro ao buscar vídeos", err);
      }
    }

    carregar();
  }, []);

  return (
    <div className="videos-page">
      

      <div className="videos-grid">
        {videos.map((v) => (
          <div key={v.id_video} className="video-card">
            <video
              src={v.video_url}
              poster={v.capa_video}   // ✅ CAPA AQUI
              controls
              preload="metadata"
              className="video-item"
            >
              Seu navegador não suporta vídeo.
            </video>
          </div>
        ))}
      </div>

      
    </div>
  );
}

export default Videos;
